<div class="display-flex-column flex-centered-container-vr pad-8">
    <img src="{{utrade_logo}}" alt="uTrade Algos" class="utrade-logo">
    <span class="text-primary-contrast-50 font-18">Welcome to <span class="font-700">uTrade Algos</span></span>
    <div class="text-center font-14 margin-32-top margin-32-bot text-primary-color-300">
        You are all set, logging you in to start trading with algos like a pro.
    </div>
    <button mat-flat-button (click)="close()" class="plans-banner-discount full-width border-radius-8 pad-4">Continue</button>
</div>